import { DocumentStatus, IdentityValidationStageName } from '../enums';
import { IdentityDocument } from './identity-document.model';
import { IdentityValidationId } from './types';

export type IdentityValidationDocument = {
  status: DocumentStatus;
};

export type IdentityValidationDocumentation = {
  picture: IdentityValidationDocument;
  document1: IdentityValidationDocument;
  document2: IdentityValidationDocument;
};

export class IdentityValidation {
  constructor(
    public readonly id: IdentityValidationId,
    public readonly stage: IdentityValidationStageName,
    public readonly documents: IdentityValidationDocumentation,
    public readonly dni?: IdentityDocument
  ) {}

  isStillEditable = (): boolean =>
    IdentityValidation.editableStages.some((editableStage) => this.stage == editableStage);

  notLongerEditable = (): boolean => !this.isStillEditable();

  haveDni = (): boolean => !!this.dni;

  private static editableStages = [
    IdentityValidationStageName.INITIALIZED,
    IdentityValidationStageName.REJECTED_WITH_RETRY_OPTION,
  ];
}

export class IdentityValidationModel {
  static isApproved = (identityValidation: IdentityValidation): boolean =>
    IdentityValidationStageName.APPROVED === identityValidation.stage;
}
